const filter = (value): string => {
  if (value.length !== 11) {
    return value
  }

  return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
}

export default filter
